import { ProductsTabs } from 'src/products/layout/ProductsTabs';
import { TariffSummary } from './TariffSummary';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { TariffSummaryGraphs } from './Graphs/TariffSummaryGraphs';
import { SelectedTariffContextProvider } from './SelectedTariffContextProvider';
import { useTabNavigationSetter } from 'src/common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter';
import { productNavigationAtom } from 'src/atoms/pages/pages';
import { useTariffSummaryUrlFromFilters } from './hooks/useTariffSummaryUrlFromFilters';
import { TariffSummaryFiltersURLParser } from './TariffSummaryURLParser';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { useTranslation } from 'react-i18next';
import { PageWithGraphs } from 'src/common/components/Layouts/PageLayout/PageWithGraphs';
import { openProductGraphsContainer } from 'src/atoms/ui/graphs';
import { ExternalRowSelectionProvider } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/ExternalRowSelectionProvider';

export const TariffSummaryPageContent = () => {
  const tariffSummaryUrl = useTariffSummaryUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: productNavigationAtom, routeToSet: tariffSummaryUrl });

  const dashboardEnabled = useHasFeatureFlag('AnalyticsModule');

  const { t } = useTranslation();
  return (
    <SelectedTariffContextProvider>
      <PageWithGraphs
        graphs={dashboardEnabled && <TariffSummaryGraphs />}
        slots={{
          graphsContainer: {
            openAtom: openProductGraphsContainer,
          },
        }}
      >
        <ProductsTabs>
          <TabPanelWithErrorHandling name={t('tariffSummary.tariffSummary')}>
            <ExternalRowSelectionProvider>
              <TariffSummary />
            </ExternalRowSelectionProvider>
          </TabPanelWithErrorHandling>
        </ProductsTabs>
      </PageWithGraphs>
    </SelectedTariffContextProvider>
  );
};

export const TariffSummaryPage = () => {
  return (
    <TariffSummaryFiltersURLParser>
      <TariffSummaryPageContent />
    </TariffSummaryFiltersURLParser>
  );
};
